import { useEffect } from 'react';
import { Alert, Button, Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getMcpHttpUrl, getMcpIntlHttpUrl } from '@/app/common/api/config';
import { McpConnectSnippet } from '@/app/Mcp/components/McpConnectSnippet';
import { useOutletContext } from 'react-router-dom';
import type { SettingsOutletContext } from '../index';

const MCP_DOCS_URL = 'https://mizfa.tools/docs/mcp/';

const McpSettings = () => {
  const [, setBreadcrumbData] = useOutletContext<SettingsOutletContext>();
  const httpUrl = getMcpHttpUrl();
  const intlHttpUrl = getMcpIntlHttpUrl();

  useEffect(() => {
    setBreadcrumbData([{ text: 'تنظیمات MCP', href: '#' }]);
  }, [setBreadcrumbData]);

  return (
    <Row className="g-0 justify-content-center">
      <Col lg={10} xl={8}>
        <Row className="g-3 align-items-start">
          <Col lg={12} xl={12}>
            <Card className="mb-0">
              <Card.Header className="border-bottom">
                <div className="d-flex align-items-center gap-2">
                  <FontAwesomeIcon icon="plug" className="text-primary" />
                  <h5 className="mb-0">تنظیمات MCP</h5>
                </div>
              </Card.Header>
              <Card.Body>
                <p className="mb-3">
                  با MCP، ابزارهای سئوی میزفا تولز مستقیم داخل دستیارهایی مثل
                  Cursor، ChatGPT، Codex، Claude و Gemini در دسترس است.
                </p>
                <Alert variant="info" className="mb-0">
                  <h6 className="alert-heading">نحوه اتصال</h6>
                  <ol className="mb-3 ps-3 fs--1">
                    <li className="mb-1">
                      پایین‌تر دو باکس می‌بینید: «سرور ایران» برای Cursor،
                      ChatGPT و Codex و «سرور خارج» برای Claude و Gemini.
                    </li>
                    <li className="mb-1">
                      آدرس همان باکس را کپی کنید و در تنظیمات MCP کلاینت بچسبانید.
                      Cursor و Codex اگر فایل تنظیمات خواستند، همان نمونه{' '}
                      <code dir="ltr">mcp.json</code> داخل باکس ایران را هم کپی
                      کنید.
                    </li>
                    <li>
                      در اولین اتصال وارد حساب میزفاتولز می‌شوید و اتصال به
                      کلاینت برقرار می‌شود.
                    </li>
                  </ol>
                  <Button
                    variant="outline-info"
                    size="sm"
                    href={MCP_DOCS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    as="a"
                  >
                    <FontAwesomeIcon icon="book" className="me-1" />
                    راهنمای اتصال هر کلاینت
                  </Button>
                </Alert>
              </Card.Body>
              <McpConnectSnippet
                httpUrl={httpUrl}
                intlHttpUrl={intlHttpUrl}
                embedded
              />
            </Card>
          </Col>

          {/* Temporarily hidden:
          <Col lg={4} xl={4}>
            <McpSessionsCard />
          </Col>
          */}
        </Row>
      </Col>
    </Row>
  );
};

export default McpSettings;
